// extracted by mini-css-extract-plugin
export default {"container":"CheckboxWithTooltip_container__iebW-","tooltip":"CheckboxWithTooltip_tooltip__aDUu6","icon":"CheckboxWithTooltip_icon__y9V3y"};